<template>
  <div class="detail-wrap">
    <!--    <el-form ref="tenant" :rules="rules" :model="tenant" :inline-message="true" class="demo-ruleForm">-->
    <div class="d-header clearfix">
      <div class="fl">
        <i class="el-icon-info"/>
        {{ dataId ? '查看' : '新增' }}分润信息
      </div>
      <div class="fr">
        <!-- <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-refresh-right">重置
        </el-button> -->
        <el-button v-if="(slBenefitSetAdd && formData.id == null) || (slBenefitSetEdit && formData.id != null)" type="primary" class="button-sty" icon="el-icon-check" @click="saveData">保存</el-button>
      </div>
    </div>
    <div>

      <!-- 工单来源 -->
      <div class="d-cont edit-mce-box">
        <div class="d-item">
          <div class="title first">
            <!-- <b>创建工单</b> -->
          </div>
          <table class="table-detail">
            <tbody>
            <tr>
              <th>认证等级</th>
              <td>
                <el-select v-model="formData.authLevel" style="width: 165px;">
                  <el-option label="待认证" :value="1"/>
                  <el-option label="初级" :value="3"/>
                  <el-option label="中级" :value="5"/>
                  <el-option label="高级" :value="7"/>
                  <el-option label="资深级" :value="9"/>
                </el-select>
              </td>

              <th>分润比列</th>
              <td>
                <el-input-number :step="1" :step-strictly="true" :controls="false" :min="0" autocomplete="off" v-model="formData.benefitRate" clearable/>
              </td>

            </tr>
            <tr>
              <th>
                <!--                <em class="f-red">*</em>-->
                创建人
              </th>
              <td>{{ formData.createBy }}</td>
              <th>
                <!--                <em class="f-red">*</em>-->
                创建时间
              </th>
              <td>{{ formData.createTime }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div>
        </div>
      </div>
    </div>
    <!--    </el-form>-->
  </div>
</template>
<script>
import {editPageMixins} from "@/mixins/tabChang";
import api from "@/api/projectApi";
import { mapGetters } from "vuex";

export default {
  mixins: [editPageMixins],
  name: 'edit',
  props: {
    _dataId: [String, Number],
  },
  components: {},
  data() {
    return {
      formData: {
        authLevel: null,  // 认证等级:1待认证、3初级、5中级、7高级、9资深级
        benefitRate: 0,  // 分润比例(为正整数)
      },

      activeName: 'first',
      isEdit: false,
      dataId: '',
    };
  },
  computed: {
    ...mapGetters(["permissions"])
  },
  created() {
    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
    this.slBenefitSetAdd = this.permissions["slBenefitSetAdd"];
    this.slBenefitSetEdit = this.permissions["slBenefitSetEdit"];
    // console.log(this.tenant,"tenant的值");
  },
  mounted() {

    this.getData();
    console.log(this.tenant, "tenant的值");
    console.log(this._dataId, "_dataId的值");
  },
  methods: {

    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        this.$http.post(api.slBenefitSet.getDataUrl, {id: this._dataId}).then(res => {
          this.formData = res.data.data
        })
      }
    },

    saveData() {
      const rules = {
        authLevel: [{prop: '认证等级', required: false, type: 'number', max: 99,}],
        benefitRate: [{prop: '分润比例(为正整数)', required: false, type: 'number', max: 999,}],
      }
      this.$validate(this.formData, rules).then(() => {
        this.$baseConfirm('您确定要保存吗？').then(() => {
          this.$mask.open()

          this.$http.post(api.slBenefitSet.saveOrUpdateUrl, this.formData).then(res => {
            this.$message.success('保存成功')
            this.goBackIndex()
            this.$mask.close()

          }).catch(() => {
              this.$message.error("保存失败！");
              this.$mask.close()
            });
        })
      })
    },

  },
};

</script>
<style lang="scss" scoped>
// 单选框
.radio_item {
  width: 24%;
  margin-top: 10px;
  margin-bottom: 10px !important;

  > span {
    display: inline-block;
    width: 120px;
    margin-right: 13px;
    text-align: right;
    font-weight: 400;
    color: rgba(86, 86, 86, 0.96);
    font-size: 12px;
  }
}

</style>
